import { Grid } from "@mui/material";
import { observer } from "mobx-react-lite";
import { PricesStorageModel } from "e.sic-platform.webclient/src/services/shop/PricesStorage";
import { useCallback, useEffect, useState } from "react";
import { api } from "e.sic-platform.webclient/src/services/api/ApiService";
import ActivityPricesTable from "./components/ActivityPricesTable";
import CheckoutSuccessModal from "./components/CheckoutFinalizerModal";
import { activityPricesStorage } from "e.sic-platform.webclient/src/services/shop/ActivityPricesStorage";
import CheckoutModal from "./components/CheckoutModal";
import CheckoutButton from "../../components/buttons/checkout-button/CheckoutButton";
import CoinPriceChart from "e.sic-platform.webclient/src/components/shop/CoinPriceChart";
import PriceStepper from "./components/PriceStepper";
import LoadingSpinner from "e.sic-platform.webclient/src/components/loading-spinner/LoadingSpinner";
import { orderStorage } from "e.sic-platform.webclient/src/services/shop/OrderStorage";
import { ChartInfoButton, CoinPricesTable } from "./components/CoinPricesTable";

export default observer(function ShopPage() {
  const coins = orderStorage.totalCredits;

  const [pricesStorage] = useState(() =>
    PricesStorageModel.create({ noPagination: true }, { api, activityPricesStorage })
  );
  const [confirmationPending, setConfirmationPending] = useState(false);
  const [minReached, setMinReached] = useState(true);
  const [showPricesTable, setShowPricesTable] = useState(false);

  const checkout = useCallback(() => {
    pricesStorage.getCheckoutSessionUrl(coins);
  }, [coins]);

  useEffect(() => {
    setMinReached(coins >= activityPricesStorage.analysisPrice);
  }, [coins, pricesStorage.prices]);

  if (pricesStorage.isLoading) return <LoadingSpinner />;

  return (
    <Grid container alignItems="flex-start" className="centered">
      <Grid xs={12} sm={8} container>
        <CheckoutSuccessModal />
        <CheckoutModal
          confirmationPending={confirmationPending}
          setConfirmationPending={setConfirmationPending}
          onConfirm={checkout}
        />
        <Grid container rowSpacing={5} columnSpacing={5} className="centered">
          <Grid item xs={12} className="centered">
            <div
              style={{
                position: "relative",
                display: "flex",
                flexDirection: "row",
              }}
            >
              <ChartInfoButton togglePanel={() => setShowPricesTable(!showPricesTable)} />

              <CoinPriceChart
                coins={coins}
                pricesStorage={pricesStorage}
              />
            </div>
          </Grid>
          <Grid item xs={9}>
            <PriceStepper
              pricesStorage={pricesStorage}
              coins={coins}
            />
          </Grid>
        </Grid>
      </Grid>
      <Grid container xs={12} sm={4} spacing={5} className="centered" mt={1}>
        <Grid item xs={12}>
          <ActivityPricesTable />
        </Grid>
        <Grid item xs={12} className="centered">
          <CheckoutButton
            disabled={!minReached}
            onClick={() => setConfirmationPending(!confirmationPending)}
          />
        </Grid>
        <Grid item xs={12} className="centered">
                <CoinPricesTable open={showPricesTable} pricesStorage={pricesStorage} />
        </Grid>
      </Grid>
    </Grid>
  );
});
